"use strict";

exports.__esModule = true;
exports.HasAccess = void 0;
var _react = _interopRequireDefault(require("react"));
var _AccessCheck = require("../AccessCheck");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Renders children only if the user has the specified permission
 */

var HasAccess = exports.HasAccess = function HasAccess(_ref) {
  var permission = _ref.permission,
    featureFlag = _ref.featureFlag,
    children = _ref.children;
  if (permission || featureFlag) {
    return /*#__PURE__*/_react["default"].createElement(_AccessCheck.AccessCheck, {
      permission: permission,
      featureFlag: featureFlag
    }, function (_ref2) {
      var isAllowed = _ref2.isAllowed;
      return isAllowed ? children : null;
    });
  } else {
    return children;
  }
};